import * as $ from "jquery";
import { ConsentHelper as ConsentHelperV2 } from './ConsentHubV2';
import { postEmailToStreamHub } from './streamHub';
import storage from "../utils/storage";
import url from '../utils/url';
import 'jquery-validation';
import '@types/jquery.validation';

$.validator.methods.email = function( value: string, element: any ) {
  return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( value );
}

export default class WebinarSignupFormWithConsent {
  domRoot: JQuery<HTMLElement>;
  params: any;
  form: JQuery<HTMLElement>;
  consentHubPromise?: Promise<any>;
  isInGDPRLocal: boolean;
  currLanguage: any;
  formLabels: any;
  addCompanyName: any;

  constructor(domRoot: HTMLElement, params: { currLanguage: any; formLabels: any; addCompanyName: any; }) {
    this.domRoot = $(domRoot);
    this.params = { ...params };

    // Component elements
    this.form = $('.webinar-signup-component--form', this.domRoot);
    this.isInGDPRLocal = false;
    this.currLanguage = params.currLanguage;
    this.formLabels = params.formLabels;
    this.addCompanyName = params.addCompanyName;
    this.init();
  }

  async init() {
    this.bindEvents();
    this.consentHubPromise = (new ConsentHelperV2(this.params, this.form)).configPromise;
    this.domRoot.on('load', () => {
      this.isInGDPRLocal = !this.form.find('.gdpr-checkbox input[type="checkbox"]').attr('checked');
    });
    this.bindFormValidation();
  }

  bindFormValidation() {
    var self = this;

    // Bind validation rules to our form using jQuery Validate functions
    var rules = {
      email: {
        required: true,
        email: true
      },
      firstname: {
        required: true
      },
      lastname: {
        required: true
      },
      job_title: {
        required: true
      },
      country: {
        required: true
      },
      company_size: {
        required: true
      }
    };

    if (this.currLanguage === 'ja') {
      rules.std1 = {
        required: true
      }
    }
    if (this.addCompanyName) {
      rules.company = {
        required: true
      }
    }

    this.form.on('submit', (event, force) => {
      this.form.validate({
        rules: rules,
        messages: {
          firstname: this.formLabels.required,
          lastname: this.formLabels.required,
          country: this.formLabels.required,
          std1: this.formLabels.required,
          job_title: this.formLabels.missingJob,
          company: this.formLabels.missingCompany,
          company_size: this.formLabels.required,
          email: this.formLabels.invalidEmail
        }
      });
      if (!force) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const hasAltEmailField = formData.has('alternate_email');
        const isEmptyAltEmail = hasAltEmailField ? this.form.find('#alternate_email').val() === "" : true;
        if (this.form.valid() && isEmptyAltEmail) {
          if(hasAltEmailField) {
            formData.delete('alternate_email');
          }
          self.consentHubPromise?.then((consentHub: { submitForm: (arg0: () => void, arg1: () => void) => void; }) => {
            consentHub.submitForm(() => self.submitSuccess(formData), () => self.submitError());
          }).catch(() => {
            self.submitError();
          });
        }
      }
    });

  }

  submitSuccess(formData: FormData) {
    const self = this;
    const userEmail = formData.get('email');
    const webinarKey = formData.get('key');
    const eventId = formData.get('eventid');

    postEmailToStreamHub(userEmail).then(() => {
      self.sendTrackingToGrowAnalytics(webinarKey, eventId);
      self.form.trigger('submit', [true])
    });
    if (self.params.saveCookie == "yes") {
      storage.setCookie(self.params.cookieKey, self.params.cookieValue, 60, 'lax');
    }
  }

  submitError() {
    if ($('.error--server', this.domRoot).length === 0) {
      this.form.after(`<div class="error error--server">${this.params.serverError}</div>`);
    }
  }
  // @TODO -- the ftl template is outdated with hardcoded IDs that should be made dynamic (i.e. uuids)
  bindEvents() {
    this.updatePartnerRef();
    setTimeout(function() {
      $(".region").change(function() {
        $("#webinarkey").attr('value', $(this).attr('data-key'));
        $("#eventid").attr('value', $(this).attr('value'));
      });
      $("#webinarkey").attr('value', $(".region").first().attr('data-key'));
      $("#eventid").attr('value', $(".region").first().attr('value'));
    }, 10);
    this.onCountrySelected();
    this.onCompanySizeSelected();
  }

  updatePartnerRef() {
    var urlParams = url.getUrlParams() || {};
    var param = urlParams["partnerref"] || false;

    if (param) {
      $("#partnerref").val(param);
    }
  }

  sendTrackingToGrowAnalytics(webinarKey: any, eventId: any){
    if(window.GROW){
      const tracking = new window.GROW.Analytics('SCI');
      tracking.send('on24_form_complete', {'webinar_key': webinarKey, 'event_id': eventId});
    }
  }

  onCountrySelected() {
    const countryDropdown = this.form.find('#country');
    countryDropdown.on('change', () => {
      const optVal= $("#country option:selected").val();
      if(optVal) {
        countryDropdown.css('color', 'rgba(0, 0, 0, 1)');
      } else {
        countryDropdown.css('color', 'rgba(0, 0, 0, 0.5)');
      }
      const additionalParams = {
        forceShowConsentMessaging: !this.isInGDPRLocal && this.isCountrySelectedGDPR(optVal),
        isAllowSetCustomLocale: !this.isInGDPRLocal,
        selectedLocale: this.params.gDPRCountries[optVal]
      };
      this.params = { ...this.params, ...additionalParams };

      this.form.find('.gdpr-checkbox').remove();
      this.consentHubPromise = (new ConsentHelperV2(this.params, this.form)).configPromise;
    });
  }

  isCountrySelectedGDPR(optVal: string | number | string[] | undefined) {
    const listOfGDPRCountries = Object.keys(this.params.gDPRCountries);
    return listOfGDPRCountries.includes(optVal);
  }

  onCompanySizeSelected(){
    const companySizeDropdown = this.form.find('#company_size');
    companySizeDropdown.on('change', () => {
      const optVal= $("#company_size option:selected").val();
      if(optVal) {
        companySizeDropdown.css('color', 'rgba(0, 0, 0, 1)');
      } else {
        companySizeDropdown.css('color', 'rgba(0, 0, 0, 0.5)');
      }
    })
  }

}
